<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-form-group label="borrado">
          <b-form-radio v-model="clear" name="some-radios" value="a">No borrar</b-form-radio>
          <b-form-radio v-model="clear" name="some-radios" value="b">borrar arreglo</b-form-radio>
          <b-form-radio v-model="clear" name="some-radios" value="c">funcion clear</b-form-radio>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-input v-model="filepass" type="password"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-file ref="fileinputx" v-model="dbjson" :multiple="true" plain></b-form-file>
      </b-col>
    </b-row>
    <template v-for = "(item, i) in config">
      <b-row v-bind:key = "'key_'+i" >
        <b-col sm="12">
          <b-card :title = "item.name">
            <b-form-file ref="fileinput" v-model="files" :multiple="true" plain></b-form-file>
            <div class="card-columns">
              <template v-for="(item, index) in vattachments">
                <div class="card" :key="'card_'+i + '_'+index">
                  <img class="card-img-top" :src="loadedFiles[index]">
                  <div class="card-body">
                    <h5 class="card-title">{{vattachments[index].name}}</h5>
                    <b-button type="button" variant="danger" @click="deleteAttachment(index)" >Eliminar</b-button>
                  </div>
                </div>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col sm="6">
        <b-form-group label="Source">
          <b-form-input v-model="stext" type="text" placeholder="ruta"></b-form-input>
          <b-form-input v-model="spass" type="password"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Target">
          <b-form-input v-model="ttext" type="text" placeholder="ruta"></b-form-input>
          <b-form-input v-model="tpass" type="password"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-btn @click="syncx">Sincronizar</b-btn>
  </div>
</template>

<script>
import PouchDB from 'pouchdb'
import PouchDBAuth from 'pouchdb-authentication'
import { mapState } from 'vuex'

export default {
  name: 'Test',
  data () {
    return {
      filepass: '',
      dbjson: {},
      clear: 'b',
      files: [],
      loadedFiles: {},
      pendingFiles: {},
      vattachments: {},
      attachments: {},
      config: [
        {
          name: 'Archivos 1'
        }
      ],
      stext: 'https://inspecta2.inmac.work:6984/inspection',
      spass: '',
      ttext: 'https://baseinspecta.aws.inmac.work/inspection',
      tpass: '',
      dbs: null,
      dbt: null,
      docs: [],
      curdoc: null,
      cont: 0
    }
  },
  computed: {
    ...mapState({
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    })
  },
  mounted () {
    PouchDB.plugin(PouchDBAuth)
    if (this.value) {
      this.vattachments = this.value
    }
  },
  watch: {
    dbjson: function (val) {
      var obj = this
      for (var i in val) {
        var reader = new FileReader()
        reader.onload = function (e) {
          var json = JSON.parse(e.target.result)
          var db = new PouchDB('http://localhost:5984/catodico')
          db.logIn('admin', obj.filepass).then(function () {
            db.bulkDocs(json).catch(function (err) { console.log(err) })
          }).catch(function (err) { console.log(err) })
        }
        reader.readAsText(val[i])
      }
    },
    curdoc: function (val) {
      var obj = this
      if (val) {
        obj.dbs.replicate.to(obj.dbt, {
          doc_ids: [val.id]
        }).then(function (msg) {
          if (msg.errors && msg.errors.length) {
            console.log(msg)
          } else {
            console.log('----' + obj.cont++)
            console.log(val)
            obj.curdoc = null
          }
        }).catch(function (err) {
          console.log(err)
        })
      } else {
        if (obj.docs.length) {
          obj.curdoc = obj.docs.pop()
        }
      }
    },
    value: function (val) {
      this.$set(this, 'vattachments', val)
      this.$emit('valuechange', val)
    },
    vattachments: function (to, from) {
      if (to !== from) {
        for (var i in to) {
          if (!(i in from)) {
            this.addLoadedFile(i)
          }
        }
      }
    },
    files (to, from) {
      let obj = this
      var arr = []
      if (Array.isArray(to)) {
        arr = to
      } else {
        if (to) {
          arr.push(to)
        }
      }
      if (arr.length) {
        var timestamp = new Date().getTime().toString()
        for (var i = 0; i < arr.length; i++) {
          var file = arr[i]
          // var name = file.name
          obj.$set(obj.attachments, timestamp, {
            content_type: file.type,
            data: file
          })
          obj.$set(obj.vattachments, timestamp, {
            name: file.name
          })
          obj.addLoadedFile(timestamp)
          timestamp++
        }
        if (obj.clear === 'b') {
          obj.$set(obj, 'files', [])
        }
        if (obj.clear === 'c') {
          obj.$refs.fileinput[0].reset()
        }
        obj.$emit('input', obj.vattachments)
      }
    }
  },
  methods: {
    syncx () {
      var obj = this
      obj.dbs = new PouchDB(obj.stext)
      obj.dbt = new PouchDB(obj.ttext)
      obj.dbs.logIn('admin', obj.spass).then(function () {
        obj.dbt.logIn('admin', obj.tpass).then(function () {
          console.log('logged to both db')
          obj.dbs.allDocs().then(function (docs) {
            obj.docs = docs.rows
            for (var j = 0; j < 990; j++) {
              obj.cont++
              obj.docs.pop()
            }
            obj.curdoc = obj.docs.pop()
            // obj.curdoc = docs.rows[4]
          }).catch(function (err) {
            console.log(err)
          })
        }).catch(function (err) {
          console.log(err)
        })
      }).catch(function (err) {
        console.log(err)
      })
      // var dbt = new PouchDB(this.ttext)
    },
    addLoadedFile (id) {
      if (this.attachments[id]) {
        this.loadedFiles[id] = window.URL.createObjectURL(this.attachments[id].data)
      }
    },
    deleteAttachment (id) {
      this.$delete(this.vattachments, id)
      this.$emit('input', this.vattachments)
      // this.emitDeleteAttachment(id)
      this.$delete(this.attachments, id)
    }
  }
}
</script>
